import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";

// État affiché quand une section n'a pas encore d'objet : mieux vaut le dire
// que simuler des données. Chaque usage indique ce qui manque et pourquoi.
export default function Unavailable({ eyebrow, title, text, note, to = "/roadmap", linkLabel = "Voir la feuille de route", testid }) {
  return (
    <div className="unavailable" data-testid={testid}>
      <span className="unavailable-icon"><Clock size={18} /></span>
      {eyebrow && <span className="eyebrow">{eyebrow}</span>}
      <h2>{title}</h2>
      <p>{text}</p>
      {note && <p className="unavailable-note">{note}</p>}
      <Link to={to} className="button button-outline">{linkLabel}<ArrowRight size={13} /></Link>
    </div>
  );
}
